import { NavigationModel } from './../../shared/models/navigation.model';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.scss']
})
export class TopNavComponent implements OnInit {
  @Input('navItems') public navItems: NavigationModel[];
  constructor() { }

  ngOnInit() {
  }

}
